import { FilterByString } from '../../../../types/types';
import Input from '../../../Input/Input';
import { FilterData } from '../../../FilterForm/FilterForm';

interface IFilterStringProps {
  onChange: (filterData: FilterData) => void;
  filter: FilterByString;
  filterData?: FilterData;
}

export default function FilterString({
  onChange,
  filter,
  filterData,
}: IFilterStringProps) {
  const handleChange = (values: string) => {
    onChange({ id: filter.id, values: [values] });
  };

  const value =
    filterData?.values && filterData.values[0] ? filterData.values[0] : '';

  return (
    <div className="ion-padding">
      <Input
        onChange={handleChange}
        value={value}
        name={filter.id}
        //TODO: Check if filter.mandatory is still needed and if it works (it probably does not)
        required={filter.mandatory}
      />
    </div>
  );
}
